import React, { useState } from "react";
import { Form, Field } from "react-final-form";

import PasswordStrength from "../../../../../components/UI/PasswordStrength/PasswordStrength";
import Modal from "../../../../../components/UI/Modal/CenterModal/CenterModalNew";
import eBoardLogo from "../../../../../assets/images/eboard-logo.png";

const NewPassword = (props) => {
  const [passwordIsVisible, setPasswordIsVisible] = useState(false);

  return (
    <Modal modalId="changePassword" modalTitle="Create a new password">
      <img
        src={eBoardLogo}
        alt="eBoard Logo"
        className="img-fluid mx-auto d-block"
        style={{ width: "200px", height: "70px", margin: "10px auto" }}
      />
      <div className="alert alert-warning">
        <i className="icon fa-warning" aria-hidden="true"></i>&nbsp;Do not
        disclose your password to anyone!
      </div>
      <Form
        onSubmit={props.changePasswordHandler}
        render={({ handleSubmit, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} autoComplete="false">
            <div
              className="form-group form-material floating"
              data-plugin="formMaterial"
            >
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="icon fa-key" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="form-control-wrap">
                  <Field
                    type="text"
                    name="otp"
                    className="form-control empty"
                    id="otp"
                    component="input"
                    required
                  />
                  <label className="floating-label" htmlFor="otp">
                    OTP as sent to your mail
                  </label>
                </div>
              </div>
            </div>
            <div
              className="form-group form-material floating"
              data-plugin="formMaterial"
            >
              <div className="input-group">
                <div
                  className="input-group-prepend"
                  onClick={() => setPasswordIsVisible(!passwordIsVisible)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="input-group-text">
                    <i
                      className={
                        !passwordIsVisible ? "icon fa-eye-slash" : "icon fa-eye"
                      }
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
                <div className="form-control-wrap">
                  <PasswordStrength
                    userPasswordChangeHandler={(password, isValid) =>
                      props.userPasswordInputChangeHandler(password, isValid)
                    }
                    inputProps={{
                      type: passwordIsVisible ? "text" : "password",
                      placeholder: "New Password",
                    }}
                    style={{ position: "absolute" }}
                  />
                </div>
              </div>
            </div>
            <div className="form-group clearfix">
              <button
                type="submit"
                className="btn btn-block btn-raised btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic"
                disabled={submitting || pristine || !props.password}
              >
                <span>
                  <i className="icon ti-thumb-up" aria-hidden="true"></i>
                  &nbsp;Reset password
                </span>
              </button>
            </div>
            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
          </form>
        )}
      />
    </Modal>
  );
};

export default NewPassword;
